import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  communityDriveNotOffered: {
    marginLeft: theme.spacing(2)
  },
  communityDriveAvailable: {
    marginLeft: 3
  },
  communityDriveInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  columnContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  notificationCard: {
    marginLeft: theme.spacing(8),
    fontSize: 12
  },
  card: {
    boxShadow: 'none',
    padding: theme.spacing(4),
    width: '100%',
    height: '100%'
  },
  noBoxShadow: {
    boxShadow: 'none'
  },
  noScore: {
    display: 'flex',
    marginLeft: theme.spacing(1),
    alignItems: 'center'
  },
  scoreContainer1stTerm: {
    alignItems: 'center',

    display: 'flex'
  },
  scoreContainer2ndTerm: {
    alignItems: 'center',

    display: 'flex'
  },
  savingsIcon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  labelAndToolTip: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(16),
    justifyContent: 'space-between'
  },
  scoreSpacer: {
    marginLeft: theme.spacing(1)
  },
  arrow: {
    height: 20,
    width: 20
  },
  info: {
    height: 24,
    width: 24
  },
  driverName: {
    marginLeft: theme.spacing(1)
  }
});

export default makeStyles(styles);
